import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { appConfig } from '@frontend/js/utils/appConfig';

export function initLaravelEcho() {
    const broadcasterDriver = appConfig.broadcastDriver;
    const reverbKey = appConfig.reverbAppKey;

    if (!broadcasterDriver || !reverbKey) {
        console.warn('[Echo] Skipped: Missing runtime config values (window.__APP_CONFIG__)');
        return;
    }

    try {
        const useTLS = appConfig.reverbScheme === 'https';
        window.Pusher = Pusher;
        // Reverb speaks the Pusher protocol, so the Echo broadcaster stays 'pusher'
        // regardless of the broadcastDriver value ('reverb'). 'cluster' is unused by
        // Reverb but pusher-js requires a non-empty value.
        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: reverbKey,
            cluster: appConfig.reverbAppCluster || 'mt1',
            wsHost: window.location.hostname,
            wsPort: appConfig.reverbPort || 6001,
            wssPort: appConfig.reverbPort || 443,
            forceTLS: useTLS,
            enabledTransports: ['ws', 'wss'],
            disableStats: true,
        });
    } catch (error) {
        console.error('[Echo] Init failed:', error);
    }
}
